import Polyglot from 'node-polyglot'
import ZHCN from './zh-CN.json'
import ZHTW from './zh-TW.json'
import EN from './en.json'
import JA from './ja.json'

const i18nMap = {
    'zh': ZHCN,
    'zh-cn': ZHCN,
    'zh-CN': ZHCN,
    'zh-TW': ZHTW,
    'en': EN,
    'en-US': EN,
    'ja': JA,
    'ja-JP': JA
}

export default (lang, phrases) => {
    if(!i18nMap[lang] && lang && phrases) i18nMap[lang] = phrases
    return new Polyglot({
        phrases: i18nMap[lang||'zh'],
        locale: lang
    })
}
